export const APP = {
  activeTool: null,
  measurePts: [],
  timeInterval: null
};
